import { useTranslation } from "react-i18next";
import { PencilRuler, Wrench } from "lucide-react";
import { TabsList, TabsRoot, TabsTrigger } from "components/common/Tabs";
import { BetaBadge } from "../BetaBadge";
import type { WorkMode } from "../utils/types";
import type { WorkModeTabsProps } from "./types";

export const WorkModeTabs = ({ value, onChange }: WorkModeTabsProps) => {
  const { t } = useTranslation();

  return (
    <TabsRoot<WorkMode>
      value={value}
      onValueChange={onChange}
      styles={{ triggerClassName: "!h-8" }}
    >
      <TabsList>
        <TabsTrigger value="planning">
          <PencilRuler className="h-3.5 w-3.5" />
          {t("smartSurveyor.workMode.planning")}
        </TabsTrigger>
        <TabsTrigger value="execution">
          <Wrench className="h-3.5 w-3.5" />
          {t("smartSurveyor.workMode.execution")}
          <BetaBadge />
        </TabsTrigger>
      </TabsList>
    </TabsRoot>
  );
};
